import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/reset.css'
import './assets/js/transition.js'
import axios from 'axios'
import Vant from 'vant'
import * as filters from './filters' // global filters
import 'vant/lib/index.css'
import 'font-awesome/css/font-awesome.css'
import VueScroller from "vue-scroller"
import store from './store'
import { Lazyload } from 'vant';
Vue.config.productionTip = false;
Vue.prototype.$axios = axios
Vue.prototype.bus = new Vue
Vue.use(Vant)
Vue.use(VueScroller)
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)

// 注册时可以配置额外的选项
import loading from './assets/lodign.gif'
import error from './assets/nullimage.jpg'
Vue.use(Lazyload, {
  lazyComponent: false,
  preLoad: 1,
  error,
  loading,
  attempt: 2,
  adapter:true
});

new Vue({
    el: '#app',
    router,
    axios,
    store,
    components: {
        App
    },
    template: '<App/>',
})

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.baseURL = "/"



// WEBPACK FOOTER //
// ./src/main.js